import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/logo-d.svg'


const _hoisted_1 = { id: "app" }
const _hoisted_2 = { class: "navigation-bar" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "clearfix" }
const _hoisted_5 = { class: "left" }
const _hoisted_6 = { class: "logo" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_8 = { class: "right" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Home")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Documentation")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("License Manager")

import { onBeforeMount, ref } from 'vue';
import store from './store';
import { util } from './util';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const showMobileMenu = ref(false);

const toggleMobileMenu = (): void => {
  showMobileMenu.value = !showMobileMenu.value;
};

const hideMobileMenu = (): void => {
  showMobileMenu.value = false;
};

onBeforeMount(() => {
  const jwt = util.getJWT();
  if (jwt) {
    store.commit('loginStatus', true);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_router_link, { to: "/" }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("i", {
              class: "uil uil-bars menu-button",
              onClick: toggleMobileMenu
            }),
            _createElementVNode("div", {
              class: _normalizeClass(["menu", { 'show-mobile': showMobileMenu.value }]),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (hideMobileMenu()))
            }, [
              (showMobileMenu.value)
                ? (_openBlock(), _createElementBlock("i", {
                    key: 0,
                    class: "uil uil-times menu-close-button",
                    onClick: toggleMobileMenu
                  }))
                : _createCommentVNode("", true),
              (showMobileMenu.value)
                ? (_openBlock(), _createElementBlock("h2", _hoisted_9, "Menu"))
                : _createCommentVNode("", true),
              _createVNode(_component_router_link, {
                class: "exact",
                to: "/"
              }, {
                default: _withCtx(() => [
                  _hoisted_10
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, { to: "/docs/" }, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, { to: "/license-manager" }, {
                default: _withCtx(() => [
                  _hoisted_12
                ]),
                _: 1
              })
            ], 2)
          ])
        ])
      ])
    ]),
    _createVNode(_component_router_view)
  ]))
}
}

})